import { observable, action } from 'mobx';
import { IFeatures } from '../../constants/Features';

export interface IProductServiceConfig {
    currency: string;
    features: IFeatures;
    graphqlExtensionVersion: string;
}

export class Config {
    @observable public config: IProductServiceConfig;

    @action
    public updateConfig(config: Partial<IProductServiceConfig>) {
        this.config = { ...this.config, ...config };
    }
}
